module.exports = __webpack_public_path__ + "img/21_108.3d5791d7.png";